module.exports = __webpack_public_path__ + "media/images/tailwind/logo-white-4fb124b10603c3fab79c77ce201fd4d7.png";